import { createElement } from "react";
import { G_ICONS, type GIconName } from "../../../shared/guest-icons";

export type { GIconName };

/** One icon from the rooms' set, as the prototype draws it: `size` px, stroked at `stroke`. */
export function GIcon({ name, size = 20, stroke = 1.8 }: { name: GIconName; size?: number; stroke?: number }) {
  return (
    <svg
      className="ic"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {G_ICONS[name].map(([tag, attrs], i) => createElement(tag, { key: i, ...attrs }))}
    </svg>
  );
}
